//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "volumeButton",
  props: ["onClick", "plusValue", "subValue", "title"],
  methods: {
    click: function(val) {
      this.onClick(val);
    }
  },
  data() {
    return {
      data: {}
    };
  }
};



// WEBPACK FOOTER //
// ./src/items/volumeButton.vue